import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Modal, Header, Icon, Label, Placeholder, Table, Toolbar } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { addCommas } from '@payfront/components/Util';
import API from '../API';
import moment from 'moment';

interface RefundModalProps{
	open?: boolean,
	onClose: ()=>void,
	refundId?: number,
}

interface Refund{
	refund_id: number,
	payment_id: number,
	user_refunder: number,
	user_refunder_email: string,
	amount: number,
	reference: string,
	auth_code: string,
	completed: boolean,
	cancelled: boolean,
	payout_id: number,
	deposit: boolean,
	date_created: number,
	pdf_link: string,
}

var RefundModal = (props: RefundModalProps)=>{
	var { t } = useTranslation();
	var [loadError, setLoadError] = useState<string>(null);
	var [refund, setRefund] = useState<Refund>(null);

	useEffect(()=>{
		if(!props.refundId || refund?.refund_id===props.refundId) return;
		if(refund?.refund_id!==props.refundId) setRefund(null);
		API.getRefund(props.refundId).then(res=>{
			if(res.error) return setLoadError(res.message);
			setRefund(res.data);
		}).catch(err=>{
			setLoadError(t('common.unexpected_error', { code: 'RFMDL-1' }));
		});
	}, [props.refundId]);

	useEffect(()=>{
		setLoadError(null);
	}, [props.open])
	
	// if(!refund_id) return null;

	return <Modal open={props.open} onClose={props.onClose} size='tiny'>
		<Modal.Header>{t('refund.title', { refund: props.refundId })}</Modal.Header>
		<Toolbar>
			<Toolbar.Item text={t('refund.download_pdf')} iconName='file-pdf' as={Link} to={refund?.pdf_link} target='_blank' className={(!refund || !refund?.pdf_link) ? 'disabled' : null} />
		</Toolbar>
		<Modal.Content>
			{loadError ? (
				<Header text={'Error'} subtext={loadError} />
			) : (
				<Table fitted details className='last' style={{ marginBottom: '-20px !important' }}>
					<Table.Row data={['ID', props.refundId]} />
					<Table.Row data={['Cantidad', <Placeholder width={50} value={refund ? `$${addCommas(refund.amount)}` : null} />]} />
					<Table.Row data={['Estatus', (
						<Placeholder width={120} random={false} height={22} value={refund ? (
							<Label style={{ minWidth: 120 }} color={refund.cancelled ? 'red' : (refund.completed ? 'green' : 'orange')}>
								{refund.cancelled ? 'Cancelado' : (refund.completed ? 'Completado' : 'Pendiente')}
							</Label>
						) : null} />
					)]} />
					<Table.Row data={['Liquidación', <Placeholder value={refund ? (
						refund?.payout_id ? (
							<Link to={`/payout/${refund.payout_id}`} target='_blank'>
								<Icon name='check' /> {refund.payout_id}
							</Link>
						) : <>
							<Icon name={refund.deposit ? 'clock' : 'remove'} />
							{refund.deposit ? 'Pendiente' : 'No conciliado'}
						</>
					) : null} />]} />
					<Table.Row data={['Fecha creación', (
						<Placeholder value={refund ? moment.unix(refund.date_created).format('DD/MM/YYYY HH:mm') : null} />
					)]} />
					<Table.Divider />
					<Table.Row data={['Referencia', <Placeholder width={50} value={refund?.reference} />]} />
					<Table.Row data={['Autorización', <Placeholder width={40} value={refund?.auth_code} />]} />
				</Table>
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button text='Cerrar' onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default RefundModal;